module.exports = __webpack_public_path__ + "img/25_12.0b73f6e2.png";